import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

const sidebarItems = [
{
  icon: 'layout',
  title: 'Dashboard',
  link: '/',
},
{
  icon: 'layout',
  title: 'User',
  link: '/user-dashboard',
},
  {
    icon: 'user-plus',
    title: 'Create User',
    link: '/users/create',
  },
  {
    icon: 'file-text',
    title: 'Create Feed',
    link: '/feeds/create',
  },
  {
    icon: 'settings',
    title: 'GenAI Control',
    link: '/admin/genai',
  },
  {
    icon: 'users',
    title: 'Fan Stories',
    link: '/admin/fan-stories',
  },
  {
    icon: 'activity',
    title: 'AI Match Update',
    link: '/admin/match-one-liner',
  },
  {
    icon: 'file-text',
    title: 'AI Match Summary',
    link: '/admin/match-summary',
  },
  {
    icon: 'file-text',
    title: 'AI Feed Summaries',
    link: '/admin/feed-summary',
  },
  {
    icon: 'star',
    title: 'Player Moments',
    link: '/player-moments',
  },
  {
    icon: 'zap',
    title: 'Gen AI',
    link: '/admin/gen-ai',
  },
  {
    icon: 'message-square',
    title: 'AI Chat Dashboard',
    link: '/admin/ai-chat-dashboard',
  },
  {
    icon: 'film',
    title: 'Reel-Script Conversations',
    link: '/admin/reel-script-conversations',
  },
  {
    icon: 'activity',
    title: 'API Latency',
    link: '/admin/api-latency',
  },
  {
    icon: 'bar-chart-2',
    title: 'API Response Stats',
    link: '/admin/api-response-stats',
  },
  {
    icon: 'heart',
    title: 'System Health',
    link: '/admin/system-health',
  },
  {
    icon: 'toggle-left',
    title: 'Feature Flags',
    link: '/admin/feature-flags',
  },
  {
    icon: 'smartphone',
    title: 'App Landing',
    link: '/admin/app-landing',
  },
  {
    icon: 'layout',
    title: 'Promo surfaces',
    link: '/admin/promo',
    matchNested: true,
  },
  {
    icon: 'bell',
    title: 'Send Notification',
    link: '/admin/send-notification',
  },
  {
    icon: 'video',
    title: 'Fan Videos',
    link: '/admin/fan-videos',
  },
  {
    icon: 'compass',
    title: 'Discover Sections',
    link: '/admin/discover-sections',
  },
  {
    icon: 'clipboard',
    title: 'Fan Scan',
    link: '/admin/fan-scan',
    matchNested: true,
  },
  {
    icon: 'book-open',
    title: 'Curated Articles',
    link: '/admin/curated-articles',
  },
  {
    icon: 'file-text',
    title: 'Blog Generator',
    link: '/admin/superblog',
  },
  {
    icon: 'image',
    title: 'Daily Digest Studio',
    link: '/admin/daily-digest-studio',
  },
  {
    icon: 'target',
    title: 'Missions',
    link: '/admin/missions',
    submenu: [
      { title: 'Missions', link: '/admin/missions' },
      { title: 'Daily Missions', link: '/admin/daily-missions?from=today' },
      { title: 'Daily Mission Analytics', link: '/admin/daily-missions/analytics' },
      { title: 'Participants', link: '/admin/missions/participants' },
    ],
  },
  {
    icon: 'calendar',
    title: 'Daily Tasks',
    link: '/admin/daily-tasks',
    matchNested: true,
    submenu: [
      { title: 'Calendar', link: '/admin/daily-tasks' },
      { title: 'Wheel', link: '/admin/daily-tasks/wheel' },
      { title: 'Bonus milestones', link: '/admin/daily-tasks/milestones' },
      { title: 'Feature flags', link: '/admin/daily-tasks/flags' },
    ],
  },
  {
    icon: 'zap',
    title: 'Pulse',
    link: '/admin/pulse',
    submenu: [
      { title: 'Cards', link: '/admin/pulse' },
      { title: 'App deck', link: '/admin/pulse/deck' },
      { title: 'Users / support', link: '/admin/pulse/actors' },
      { title: 'Matches', link: '/admin/pulse/matches' },
      { title: 'Competitions', link: '/admin/pulse/competitions' },
      { title: 'Knowledge', link: '/admin/pulse/knowledge' },
      { title: 'Hot takes', link: '/admin/pulse/hot-takes' },
      { title: 'Analytics', link: '/admin/pulse/analytics' },
    ],
  },
  {
    icon: 'flag',
    title: 'Reports',
    link: '/admin/reports',
    submenu: [
      { title: 'Report User', link: '/admin/reports/users' },
      { title: 'Report Post', link: '/admin/reports/posts' },
    ],
  },
  {
    icon: 'users',
    title: 'Referrals',
    link: '/admin/referrals-dashboard',
    submenu: [
      { title: 'Analytics', link: '/admin/referrals-dashboard' },
      { title: 'Referral Codes', link: '/admin/referrals/codes' },
      { title: 'Delete fan (dev)', link: '/admin/users/delete' },
    ],
  },
  {
    icon: 'layout',
    title: 'Player',
    link: '/player-dashboard',
  },
  {
    icon: 'layout',
    title: 'Match',
    link: '/match-dashboard',
  },
  {
    icon: 'radio',
    title: 'Dummy live',
    link: '/admin/dummy-live',
  },
  {
    icon: 'credit-card',
    title: 'Payments',
    link: '/admin/payments',
  },
  {
    icon: 'layout',
    title: 'Post Highlights',
    link: '/highlights',
  },
  {
    icon: 'layout',
    title: 'Player Photo',
    link: '/player-photo',
  },
  {
    icon: 'trending-up',
    title: 'Sponsored Ads',
    link: '/sponsored-ads',
    submenu: [
      {
        title: 'Dashboard',
        link: '/sponsored-ads'
      },
      {
        title: 'Ad Users',
        link: '/sponsored-ads/users'
      },
      {
        title: 'Ad Sets',
        link: '/sponsored-ads/adsets'
      },
      {
        title: 'Ads',
        link: '/sponsored-ads/ads'
      },
      {
        title: 'Campaigns',
        link: '/sponsored-ads/campaigns'
      }
    ]
  }
];

const userSidebarItems = [
  {
    icon: 'file-text',
    title: 'Create Feed',
    link: '/feeds/create',
  },
];

function pathOnly(link) {
  return String(link || '').split('?')[0];
}

function topLevelIsActive(item, pathname) {
  if (pathname === item.link) return true;
  return Boolean(item.matchNested && item.link !== '/' && pathname.startsWith(`${item.link}/`));
}

function submenuIsActive(link, siblings, pathname) {
  const path = pathOnly(link);
  if (pathname === path) return true;
  if (!pathname.startsWith(`${path}/`)) return false;
  return !siblings.some((other) => {
    const otherPath = pathOnly(other.link);
    return (
      otherPath !== path &&
      otherPath.startsWith(`${path}/`) &&
      (pathname === otherPath || pathname.startsWith(`${otherPath}/`))
    );
  });
}

function SideBar() {
  const location = useLocation();
  const [expandedMenu, setExpandedMenu] = useState(() => {
    const index = sidebarItems.findIndex((item) =>
      item.submenu?.some((sub) => submenuIsActive(sub.link, item.submenu, location.pathname))
    );
    return index === -1 ? null : index;
  });
  const isCreatedByAdmin = useSelector((state) => state.roleReducer.isCreatedByAdmin);

  const items = isCreatedByAdmin ? userSidebarItems : sidebarItems;

  const toggleSubmenu = (index) => {
    setExpandedMenu(expandedMenu === index ? null : index);
  };

  return (
    <div>
      <header className="main-nav">
        <nav>
          <div className="main-navbar">
            <div className="left-arrow" id="left-arrow"><i data-feather="arrow-left"></i></div>
            <div id="mainnav">
              <ul className="nav-menu custom-scrollbar">
                <li className="back-btn">
                  <div className="mobile-back text-end"><span>Back</span><i className="fa fa-angle-right ps-2" aria-hidden="true"></i></div>
                </li>
                <li className="sidebar-main-title">
                  <div>
                    <h6>{isCreatedByAdmin ? 'Panel' : 'Dashboard'}</h6>
                  </div>
                </li>
                {items.map((item, index) => (
                  <li key={index}>
                    {item.submenu ? (
                      <>
                        <a
                          className={`nav-link menu-title ${expandedMenu === index ? 'active' : ''}`}
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            toggleSubmenu(index);
                          }}
                        >
                          <i data-feather={item.icon}></i>
                          <span>{item.title}</span>
                          <i className={`fa fa-angle-${expandedMenu === index ? 'down' : 'right'} submenu-arrow`}></i>
                        </a>
                        <ul className={`nav-submenu ${expandedMenu === index ? 'show' : ''}`}>
                          {item.submenu.map((subItem, subIndex) => (
                            <li key={subIndex}>
                              <a
                                className={`nav-link ${submenuIsActive(subItem.link, item.submenu, location.pathname) ? 'active' : ''}`}
                                href={subItem.link}
                              >
                                <span>{subItem.title}</span>
                              </a>
                            </li>
                          ))}
                        </ul>
                      </>
                    ) : (
                      <a
                        className={`nav-link menu-title link-nav ${topLevelIsActive(item, location.pathname) ? 'active' : ''}`}
                        href={item.link}
                      >
                        <i data-feather={item.icon}></i>
                        <span>{item.title}</span>
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            </div>
            <div className="right-arrow" id="right-arrow"><i data-feather="arrow-right"></i></div>
          </div>
        </nav>
      </header>
    </div>
  );
}

export default SideBar;
